/**
 * Keyboard utility functions for accessibility
 */
import { TAG_MANAGER_STRINGS } from '../constants';

/**
 * Checks if the pressed key is a selection key (Enter or Space)
 * Used for keyboard accessibility to trigger actions
 */
export const isSelectKey = (key: string): boolean => {
  return key === TAG_MANAGER_STRINGS.ENTER || key === TAG_MANAGER_STRINGS.SPACE;
};

/**
 * Checks if the pressed key is an arrow key
 * Used for keyboard navigation
 */
export const isArrowKey = (key: string): boolean => {
  const arrowKeys: readonly string[] = [
    TAG_MANAGER_STRINGS.ARROW_RIGHT,
    TAG_MANAGER_STRINGS.ARROW_LEFT,
    TAG_MANAGER_STRINGS.ARROW_DOWN,
    TAG_MANAGER_STRINGS.ARROW_UP
  ];
  return arrowKeys.includes(key);
};
